<template>
    <svg tabindex="-1" :class="['icon', sizeClass]" focusable="false">
        <use v-bind="{ 'xlink:href': symbolName }"></use>
    </svg>
</template>

<script>
    const PLACEHOLDER_SYMBOL = 'placeholder';
    const DEFAULT_SYMBOL_SIZE = 'default';

    export default {
        mixins: [],

        props: {
            symbol: String,
            size: String,
        },
        computed: {
            sizeClass() {
                return (this.size ? `icon__${ this.size }` : '');
            },
            symbolName() {
                const hasSize = this.size && this.size !== DEFAULT_SYMBOL_SIZE;

                if (this.symbol) {
                    return `#${ hasSize ? `${ this.size }--` : '' }${ this.symbol }`;
                }

                return `#${ PLACEHOLDER_SYMBOL }`;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2290ff72